// dependencies
import React from "react";
import PropTypes from "prop-types";

// style
import css from "./Spinner";

const Spinner = (props) => {
	const style = {
		height: props.size,
		width: props.size,
	};

	if (props.centered) {
		style.margin = "0 auto";
	}

	const colorClass = css[`${props.color}Color`];

	return <div style={style} className={`${css.Spinner} ${props.className} ${colorClass}`} />;
};

Spinner.propTypes = {
	centered: PropTypes.bool,
	size: PropTypes.number,
	className: PropTypes.string,
	color: PropTypes.string,
};

Spinner.defaultProps = {
	className: "",
	size: 20,
	centered: false,
	color: "blue",
};

export default Spinner;
